import { PlusCircleFilled } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Button } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { UsersSearch } from '@/components'
import { userInfoAtom } from '@/modules/user'
import { ResourceType } from '@/schemas'

// import { ga, traceEvent } from '@/utils/ga'

interface AddUserProps {
  resourceType: ResourceType
  onSuccess: (email?: string) => void
}

export const AddUser: React.FC<AddUserProps> = ({ resourceType, onSuccess }) => {
  const [viewer] = useAtom(userInfoAtom)
  const hasAddUserPermission = viewer.roles.find((r) => r.role === `${resourceType}_committee`) || viewer.isSuperAdmin

  const { t } = useTranslation()
  const [addingUser, setAddingUser] = React.useState(false)

  const { run } = useRequest(
    (email: string) => ({
      url: '/api/permissions/committee/permission',
      method: 'patch',
      data: {
        email,
        resourceType,
      },
    }),
    {
      manual: true,
    }
  )

  const onChange = async (email?: string) => {
    if (!email) {
      setAddingUser(false)
      return
    }
    await run(email)
    onSuccess(email)
    setAddingUser(false)
  }

  return hasAddUserPermission ? (
    addingUser ? (
      <UsersSearch
        autoFocus
        open
        className='mr-2 w-160px'
        placeholder={t('add users')}
        onChange={onChange}
        onBlur={() => setAddingUser(false)}
      />
    ) : (
      <div className='mr-2 w-40'>
        <div className='cursor-pointer flex items-center' onClick={() => setAddingUser(true)}>
          <Button
            type='text'
            icon={<PlusCircleFilled style={{ fontSize: 18 }} />}
            style={{ display: 'flex', alignItems: 'center', paddingLeft: 6 }}
          >
            {t('add users')}
          </Button>
        </div>
      </div>
    )
  ) : null
}
